import Object3d from './Object3d';
import Container from './Container';
import Frustum from './Frustum';
import * as mat4 from './glMatrix/mat4';
import * as vec3 from './glMatrix/vec3';
import * as vec2 from './glMatrix/vec2';
import * as quat from './glMatrix/quat';

const TOUCH      = ('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0);
const POINTER    = !!window.navigator.pointerEnabled;
const MS_POINTER = !!window.navigator.msPointerEnabled;

const POINTER_DOWN = TOUCH ? 'touchstart' : (POINTER ? 'pointerdown' : (MS_POINTER ? 'MSPointerDown' : 'mousedown' ) ); 
const POINTER_MOVE   = TOUCH ? 'touchmove'  : (POINTER ? 'pointermove' : (MS_POINTER ? 'MSPointerMove' : 'mousemove' ) ); 
const POINTER_UP = TOUCH ? 'touchend'   : (POINTER ? 'pointerup'   : (MS_POINTER ? 'MSPointerUp'   : 'mouseup'   ) ); 

// var objects = []


class Camera extends Object3d {

  constructor(options) {
    
    super();

    this.touchEventPageX = 0
    this.touchEventPageY = 0

    this._onPointerDown = this._onPointerDown.bind(this);
    this._onPointerMove = this._onPointerMove.bind(this);
    this._onPointerUp   = this._onPointerUp.bind(this);
    this._onMouseWheel  = this._onMouseWheel.bind(this);
    this.onContextMenu  = this.onContextMenu.bind(this);
    this._handleOrientation   = this._handleOrientation.bind(this)




  this._projScreenMatrix = mat4.create()

    options = Object.assign({},{
      fov:    45,
      aspect: window.innerWidth / window.innerHeight,
      near:   10,
      far:    1000,
      type:  'perspective',
      left:   0,
      right:  0,
      top:    0,
      bottom: 0,
      orbitControl: false,
      wheel: true,
      lookAt: null,
      pointerParent: document,
      firstPerson: false,
      lookAround: false,
      playerCamera: false,
      tilt: false,
      moveSpeed: 1,
      wheelSpeed: 1,
      distance: 20,
      position: [0,0,0],
      frustum: false,
      cameraDistance: 100,
      theta: 0,
      phi: 0,
      minTheta: -Math.PI,
      maxTheta: Math.PI,
      minPhi:   Math.PI * -.5,
      maxPhi:   Math.PI * 0.5,
      minCameraDistance: 0,
      maxCameraDistance: 10000,
      offset: [0,0,0],
      drag: false,

      cameraTiltTheta: 0.1,
      cameraTiltPhi: 0.05,
    }, options);



    this._cameraTiltTheta = options.cameraTiltTheta// 0.1
    this._cameraTiltPhi   = options.cameraTiltPhi//0.05


    this.playerCamera = options.playerCamera

    this.drag = options.drag;
    this.dragDirX = vec2.create()
    this.dragDirY = vec2.create()

    this.offset = options.offset;

    this.minCameraDistance = options.minCameraDistance
    this.maxCameraDistance = options.maxCameraDistance

    this.theta = options.theta;
    this.phi   = options.phi;

    this.pointerTheta = 0
    this.pointerPhi   = 0
    this.currPointerPhi = 0
    this.currPointerTheta = 0

    this.minTheta= options.minTheta
    this.maxTheta= options.maxTheta
    this.minPhi= options.minPhi
    this.maxPhi= options.maxPhi

    this.frustum = options.frustum ? new Frustum() : null

    this.lookAt = options.lookAt
    this.fov    = options.fov;
    this.aspect = options.aspect;
    this.near   = options.near;
    this.far    = options.far;
    this.type   = options.type;
    this.left   = options.left;
    this.right  = options.right;
    this.top    = options.top;
    this.bottom = options.bottom;
    this.orbitControl = options.orbitControl;
    this.tilt = options.tilt;
    this.firstPerson = options.firstPerson;
    this.lookAround = options.lookAround
    this.wheel = options.wheel;

    this.projectionMatrix = mat4.create();
    this.inverseProjectionMatrix = mat4.create()
    this.updateProjectionMatrix();

    if ( this.orbitControl || this.tilt || this.firstPerson || this.lookAround) {
      if (!this.lookAt) {
        this.lookAt = vec3.create();
        vec3.set(this.lookAt, 0,0,0 );
      }

      this.originalLookAt = vec3.create();
      vec3.copy(this.originalLookAt, this.lookAt);

      this._pointerParent = options.pointerParent
      this._initPointerEvents();
      this._cameraDistance  = options.cameraDistance;
      // objects.push(this);
    }

    if (this.firstPerson) {
      document.addEventListener("contextmenu", this.onContextMenu.bind(this), false);
      document.addEventListener("keydown", this.onKeyDown.bind(this), false);
      document.addEventListener("keyup", this.onKeyUp.bind(this), false);
    }

    this.pitchObject = new Container();
    this.yawObject   = new Container();
    this.yawObject.add( this.pitchObject );
    this.moveSpeed = options.moveSpeed;
    this.wheelSpeed = options.wheelSpeed
    this.time = Date.now();
    this._velocity     = vec3.create();
    this._moveForward  = false;
    this._moveBackward = false;
    this._moveLeft     = false;
    this._moveRight    = false;
    this._moveUp       = false;
    this._camera = vec3.create()
    this._oldPosition = vec3.create();

    this.position[0]      = options.position[0];
    this.position[1]      = options.position[1];
    this.position[2]      = options.position[2];
    this._oldPosition[0]  = this.position[0];
    this._oldPosition[1]  = this.position[1];
    this._oldPosition[2]  = this.position[2];

    this.currPointerXMove = 0
    this.currPointerYMove = 0
  }

  updateProjectionMatrix() {
    if (this.type == 'perspective') {
      mat4.perspective(this.projectionMatrix, this.fov * Math.PI/180.0, this.aspect, this.near, this.far);
    }
    else if(this.type == 'orthographic' || this.type == 'ortho'){
      mat4.ortho(this.projectionMatrix, this.left, this.right, this.bottom, this.top, this.near, this.far);
    }

    mat4.invert(this.inverseProjectionMatrix, this.projectionMatrix);


  }

  _initPointerEvents() {

    this.winWidth = window.innerWidth;
    this.winHeight = window.innerHeight;
    this._isPointerDown = false;
    this.isRightClick = false;

    this.pointerXMove    = 0;
    this.pointerYMove    = 0;


    this.pointerX = 0;
    this.pointerY = 0;
    this.pointerZ = 0;
    this.lastPointerX = 0;
    this.lastPointerY = 0;
    this.lastPointerZ = 0;
    this.currTheta =  0;
    this.currPhi =  0;
    this._minPolarAngle = Math.PI * -.2; // radians
    this._maxPolarAngle = Math.PI * .4; // radians

  
    this.thetaDown = this.theta;
    this.phiDown   = this.phi;


    this._pointerParent.addEventListener(POINTER_DOWN, this._onPointerDown, {passive:false});
    document.addEventListener(POINTER_MOVE, this._onPointerMove, {passive:false});
    document.addEventListener(POINTER_UP, this._onPointerUp, {passive:false});

    // if (window.DeviceMotionEvent && typeof window.DeviceMotionEvent.requestPermission === 'function') {
    //   document.addEventListener('click', function () {
    //       DeviceOrientationEvent.requestPermission().then(response => {
    //         if (response == 'granted') {
    //           window.addEventListener("deviceorientation", this._handleOrientation, true);
    //         }
    //       }).catch(console.error)
    //   });
    // }
    // else {
    //   window.addEventListener("deviceorientation", this._handleOrientation, true);
    // }

    
    this._pointerParent.addEventListener( "contextmenu", this.onContextMenu, false);
    if (this.wheel) {  
      this._pointerParent.addEventListener( 'DOMMouseScroll', this._onMouseWheel,  {passive:false} );
      this._pointerParent.addEventListener( 'mousewheel',     this._onMouseWheel,  {passive:false} );
    }
  }

  delete() {
    this._pointerParent.removeEventListener(POINTER_DOWN, this._onPointerDown, false);
    document.removeEventListener(POINTER_MOVE, this._onPointerMove, false);
    document.removeEventListener(POINTER_UP, this._onPointerUp, false);
    this._pointerParent.removeEventListener( "contextmenu", this.onContextMenu, false);
    if (this.wheel) {
      this._pointerParent.removeEventListener( 'DOMMouseScroll', this._onMouseWheel,  {passive:false} );
      this._pointerParent.removeEventListener( 'mousewheel',     this._onMouseWheel,  {passive:false} );
    }
    document.removeEventListener("keydown", this.onKeyDown, false);
    document.removeEventListener("keyup", this.onKeyUp, false);
  }

  destroy() {
    this.delete()
  }
  
  onContextMenu(e) {
    event.preventDefault();
  }


  
  

  onKeyDown(event) {
    switch ( event.keyCode ) {
      // case 38: // up
      case 87: // w
        this._moveForward = true;
        break;
      // case 37: // left
      case 65: // a
        this._moveLeft = true; 
        break;
      // case 40: // down
      case 83: // s
        this._moveBackward = true;
        break;
      // case 39: // right
      case 68: // d
        this._moveRight = true;
        break;
      case 32: // space
        this._velocity[1] += 5;
        break;
    }
  }
  onKeyUp(event) {
    switch( event.keyCode ) {
      case 38: // up
      case 87: // w
        this._moveForward = false;
        break;
      case 37: // left
      case 65: // a
        this._moveLeft = false;
        break;
      case 40: // down
      case 83: // s
        this._moveBackward = false;
        break;
      case 39: // right
      case 68: // d
        this._moveRight = false;
        break;
    }
  }

  _onMouseWheel(e) {
    if (this.disabled) {
      return;
    }
    // e.preventDefault();
    // e.stopPropagation();
    var wheelDeltaX, wheelDeltaY;
    if ( e.wheelDelta ){
        wheelDeltaX = wheelDeltaY = e.wheelDelta; //6 or 12
    } else if ( e.detail ){
        wheelDeltaX = wheelDeltaY = -e.detail * 40; // *3
    } else if ( e.wheelDeltaX ) {
        wheelDeltaY = e.wheelDeltaY/12;
        wheelDeltaX = -1 * e.wheelDeltaX/12; 
    } else if ( e.axis !== undefined && e.axis === e.HORIZONTAL_AXIS ) {
        wheelDeltaY = 0;
        wheelDeltaX = -1 * wheelDeltaY;
    } else {
        wheelDeltaY = 0;
        wheelDeltaX = 0;
    }
    this._cameraDistance += wheelDeltaY * -1 * this.wheelSpeed//0.001;
    this._cameraDistance = Math.min(this.maxCameraDistance, Math.max(this.minCameraDistance, this._cameraDistance))
  }

  disable() {
    this.disabled = true
  }
  enable() {
    this.disabled = false
  }

  _onPointerDown(event) {

    
    if (this.disabled) {
      return;
    }
    
    if (event.which == 3) {
      this.isRightClick = true;
    }
    
    document.body.classList.add("is-dragging")
    this._isPointerDown = true;
    
    this.touchEvent  = TOUCH ? (event.touches[0] || event.changedTouches[0]) : event;
    
    // if (!this.lookAround) {
      this.touchEventPageX = this.touchEvent.pageX;
      this.touchEventPageY = this.touchEvent.pageY;
      this.touchEventPageX -= window.pageXOffset || document.documentElement.scrollLeft;
      this.touchEventPageY -= window.pageYOffset || document.documentElement.scrollTop;
      this.pointerXDown     = this.touchEventPageX;
      this.pointerYDown     = this.touchEventPageY;

      this.startPointerX    = this.pointerXMove;
      this.startPointerY    = this.pointerYMove;

      if (this.drag) {
        vec2.set( this.dragDirY, this.position[0], this.position[2] );
        vec2.subtract( this.dragDirY, this.dragDirY, [this.lookAt[0], this.lookAt[2]] );
        vec2.normalize( this.dragDirY, this.dragDirY );
        vec2.set( this.dragDirX, this.dragDirY[1], -this.dragDirY[0] );
      }

      if (!this.tilt) {
        this.thetaDown = this.theta;
        this.phiDown   = this.phi;
      }


    // }

  }

  _handleOrientation() {
    // if (this._isPointerDown) {
    //   return
    // }
    // if (this.playerCamera) {
    //   this.pointerRatio[0] = (event.gamma) / 25
    //   this.pointerRatio[1] = (event.beta-45) / 25
    //   this.pointerTheta = (  (event.gamma) / 25  * 0.1 * -1  );
    //   this.pointerPhi   = ( (event.beta-45) / 25 * 0.05 * -1);
    // }
  }

  _onPointerMove(event) {

    if( (!this._isPointerDown && !document.pointerLockElement && (!this.lookAround && !this.tilt)) || this.disabled){
      return;
    }

    if (this._isPointerDown) {
      event.preventDefault();
      if (TOUCH) event.stopPropagation();
    }

    if (/*this.isRightClick || */
        this._isPointerDown && this.drag
        ) {
      let touchEvent  = TOUCH ? (event.touches[0] || event.changedTouches[0]) : event;
      let touchEventPageX = touchEvent.pageX;
      let touchEventPageY = touchEvent.pageY;
      touchEventPageY -= window.pageYOffset || document.documentElement.scrollTop;
      this.pointerXMove = this.startPointerX 
                        + (this.dragDirY[0] * (touchEventPageY - this.pointerYDown) * -1 ) 
                        + (this.dragDirX[0] * (touchEventPageX - this.pointerXDown) * -1 * 0.5)
      this.pointerYMove = this.startPointerY 
                        + (this.dragDirY[1] * (touchEventPageY - this.pointerYDown) * -1 ) 
                        + (this.dragDirX[1] * (touchEventPageX - this.pointerXDown) * -1 * 0.5)
      return
    }


      if (!!document.pointerLockElement) {
        this.touchEvent  = event;
        this.touchEventPageX += this.touchEvent.movementX;
        this.touchEventPageY += this.touchEvent.movementY;
        this.touchEventPageY = Math.max(0, Math.min(window.innerHeight, this.touchEventPageY))
        this.pointerXOrbiter = (this.touchEventPageX);
        this.pointerYOrbiter = (this.touchEventPageY);
        this.theta = ( ((this.pointerXOrbiter / window.innerWidth)-0.5) * Math.PI) * -1;
        this.phi   = ( ((this.pointerYOrbiter / window.innerHeight)-0.5) * Math.PI );
      }
      else {
        this.touchEvent  = TOUCH ? (event.touches[0] || event.changedTouches[0]) : event;
        this.touchEventPageX = this.touchEvent.pageX;
        this.touchEventPageY = this.touchEvent.pageY;
        // this.touchEventPageX -= window.pageXOffset || document.documentElement.scrollLeft;
        this.touchEventPageY -= window.pageYOffset || document.documentElement.scrollTop;

        if (this.lookAround || this.tilt) {
          if (this.tilt) {
            this.pointerXOrbiter = this.touchEventPageX;
            this.pointerYOrbiter = this.touchEventPageY;
            this.theta = this.thetaDown + ( ((this.pointerXOrbiter / window.innerWidth - .5) * 2) * Math.PI/(20/2)  *-1  );//20
            this.phi   = this.phiDown   + ( ((this.pointerYOrbiter / window.innerHeight - .5) * 2) * Math.PI/30   );//30
            this.phi   = Math.max( this.minPhi, Math.min( this.maxPhi, this.phi ) );
            this.theta = Math.max( this.minTheta, Math.min( this.maxTheta, this.theta ) );
          }
          else {
            if (this.playerCamera) {
              if (this._isPointerDown) {
                this.pointerXOrbiter = (this.pointerXDown - this.touchEventPageX);
                this.pointerYOrbiter = (this.pointerYDown - this.touchEventPageY);
                this.theta = this.thetaDown + ( ((this.pointerXOrbiter / window.innerWidth ) * 2)  * Math.PI/4 * -1 );
                this.phi   = this.phiDown   + ( ((this.pointerYOrbiter / window.innerHeight ) * 2) * Math.PI/8 * -1 );
              }

              this.pointerTheta = ( ((this.touchEventPageX / window.innerWidth - .5) * 2)  * this._cameraTiltTheta * -1  );
              this.pointerPhi   = ( ((this.touchEventPageY / window.innerHeight - .5) * 2) * this._cameraTiltPhi * -1);
            }
            else {
              this.pointerXOrbiter = this.touchEventPageX;
              this.pointerYOrbiter = this.touchEventPageY;
              this.theta = ( ((this.pointerXOrbiter / window.innerWidth - .5) * 2) * Math.PI*0.4 *-1);
              this.phi   = ( ((this.pointerYOrbiter / window.innerHeight - .5) * 2) * Math.PI*0.125 *-1);
            }
            this.phi   = Math.max( this._minPolarAngle, Math.min( this._maxPolarAngle, this.phi ) );
          }
        }
        else {
          this.pointerXMove = this.startPointerX + (this.touchEventPageX - this.pointerXDown);
          this.pointerYMove = this.startPointerY + (this.touchEventPageY - this.pointerYDown);
          this.pointerXOrbiter = (this.pointerXDown - this.touchEventPageX);
          this.pointerYOrbiter = (this.pointerYDown - this.touchEventPageY);
          this.theta = this.thetaDown + ( this.pointerXOrbiter / window.innerWidth * 2 * Math.PI);
          this.phi   = this.phiDown   + ( this.pointerYOrbiter / window.innerHeight * 2 * Math.PI * -1);
          this.phi   = Math.max( this._minPolarAngle, Math.min( this._maxPolarAngle, this.phi ) );
       
        }
        
      }

  }

  _onPointerUp() {
    this._isPointerDown = false;
    this.isRightClick = false;
    document.body.classList.remove("is-dragging")
  }

  update(force) {


    if (this.orbitControl) {
        this.currTheta += (this.theta - this.currTheta) * 0.1;
        this.currPhi   += (this.phi - this.currPhi) * 0.8;
        this.position[0] = this.offset[0] +  Math.sin(this.currTheta) * Math.cos(this.currPhi) * this._cameraDistance;
        this.position[1] = this.offset[1] + Math.sin(this.currPhi)   * this._cameraDistance;
        this.position[2] = this.offset[2] +  Math.cos(this.currTheta) * Math.cos(this.currPhi) * this._cameraDistance;
        this.lookAt[0] = this.offset[0]//0.000000001//this.pointerXMove / -100;
        this.lookAt[1] = this.offset[1]//0.000000001//this.pointerYMove / 100; 
        this.lookAt[2] = this.offset[2]//0.000000001
        super.render(true);
    }
    else if (this.tilt) {
        this.currTheta += (this.theta - this.currTheta) * 0.05;
        this.currPhi   += (this.phi - this.currPhi) * 0.05;
        

        let dragY = vec3.create()
        vec3.copy( dragY, this.position );
        vec3.subtract( dragY, dragY, this.lookAt );
        vec3.normalize( dragY, dragY  );
        
          // this.pointerYMove

        this.currPointerXMove += (this.pointerXMove - this.currPointerXMove) * 0.15
        this.currPointerYMove += (this.pointerYMove - this.currPointerYMove) * 0.15

        this.position[0] = this.offset[0] + (this.currPointerXMove) + Math.sin(this.currTheta) * Math.cos(this.currPhi) * this._cameraDistance;
        this.position[1] = this.offset[1] + Math.sin(this.currPhi) * this._cameraDistance;
        this.position[2] = this.offset[2] + (this.currPointerYMove) + Math.cos(this.currTheta) * Math.cos(this.currPhi) * this._cameraDistance;
        
        this.lookAt[0]  = this.offset[0] + (this.currPointerXMove) + Math.sin(this.currTheta) * Math.cos(this.currPhi) * this._cameraDistance * -1
        this.lookAt[1]  = this.offset[1] + Math.sin(this.currPhi)   * this._cameraDistance * -1
        this.lookAt[2]  = this.offset[2] + (this.currPointerYMove) + Math.cos(this.currTheta) * Math.cos(this.currPhi) * this._cameraDistance * -1
        super.render(true);
    }
    else if (this.lookAround)
    {

        this.theta = Math.max( this.minTheta, Math.min( this.maxTheta, this.theta ) )

        this.currTheta += ((this.theta)- this.currTheta) * 0.15;
        this.currPhi   += ((this.phi ) - this.currPhi) * 0.15;
        this.currPointerTheta += ((this.pointerTheta)- this.currPointerTheta) * 0.05;
        this.currPointerPhi   += ((this.pointerPhi ) - this.currPointerPhi) * 0.05;
        this.lookAt[0]   = this.offset[0] + Math.sin(this.currTheta + this.currPointerTheta + (this.rotationY||0)) * Math.cos(this.currPhi + this.currPointerPhi) * 100 
        this.lookAt[1]   = this.offset[1] + Math.sin(this.currPhi + this.currPointerPhi ) * 100;
        this.lookAt[2]   = this.offset[2] + Math.cos(this.currTheta + this.currPointerTheta + (this.rotationY||0)) * Math.cos(this.currPhi + this.currPointerPhi) * 100 

        // if (this.playerCamera) {
        //   this.position[0] = this.offset[0] + Math.sin(this.currTheta + this.currPointerTheta + (this.rotationY||0)) * Math.cos(this.currPhi + this.currPointerPhi) * 70 * -1
        //   this.position[1] = this.offset[1] + Math.sin(this.currPhi + this.currPointerPhi ) * 70 * -1
        //   this.position[2] = this.offset[2] + Math.cos(this.currTheta + this.currPointerTheta + (this.rotationY||0)) * Math.cos(this.currPhi + this.currPointerPhi) * 70 * -1
        // }
        // else {
          this.position[0] = this.offset[0] //+ Math.sin(this.currTheta + this.currPointerTheta + (this.rotationY||0)) * Math.cos(this.currPhi + this.currPointerTheta) * 100 * -1
          this.position[1] = this.offset[1] //+ Math.sin(this.currPhi + this.currPointerTheta ) * -1
          this.position[2] = this.offset[2] //+ Math.cos(this.currTheta + this.currPointerTheta + (this.rotationY||0)) * Math.cos(this.currPhi + this.currPointerTheta) * 100 * -1
        // }
        super.render();
    }
    else if (this.firstPerson)
    {
        var time = Date.now();
        var delta = ( time - this.time ) / 1000;
        this.prevTime = time;
        this._velocity[0] -= this._velocity[0] * 4 * delta;
        this._velocity[1] -= this._velocity[1] * 4 * delta;
        this._velocity[2] -= this._velocity[2] * 4 * delta;

        if (this.position[1] < 0 && this._velocity[1] < 0) {
          this._velocity[1] = 0;
          this.position[1] = 0 
        }

        if ( this._moveForward )  this._velocity[2] -= (this.moveSpeed) * delta;
        if ( this._moveBackward ) this._velocity[2] += (this.moveSpeed) * delta;
        if ( this._moveLeft )     this._velocity[0] -= (this.moveSpeed) * delta;
        if ( this._moveRight )    this._velocity[0] += (this.moveSpeed) * delta;
        
        this._camera[0] = this._velocity[0];
        this._camera[1] = this._velocity[1];
        this._camera[2] = this._velocity[2];

        this.currTheta += (this.theta - this.currTheta) * 0.1;
        this.currPhi   += (this.phi - this.currPhi) * 0.1;

        //first we reset position to center and rotate the camera
        this._oldPosition[0] = this.position[0];
        this._oldPosition[1] = this.position[1];
        this._oldPosition[2] = this.position[2];
        this.position[0] = 0;
        this.position[1] = 0;
        this.position[2] = 0;
        this.lookAt[0] = Math.sin(this.currTheta) * Math.cos(this.currPhi) * 100 ;
        this.lookAt[1] = Math.sin(this.currPhi) * 100 * -1 ;
        this.lookAt[2] = Math.cos(this.currTheta) * Math.cos(this.currPhi) * 100 ;
        this.updateMatrix()
        
        //then we translate the camera based on velocity to folow view direction
        var _matrix = mat4.create();
        mat4.copy(_matrix, this.matrix);
        mat4.translate( _matrix, _matrix, this._camera);
        var _pos = vec3.create()
        mat4.getTranslation(_pos, _matrix);
        this.position[0] = this._oldPosition[0] + _pos[0]
        this.position[1] = this._oldPosition[1] + _pos[1]
        this.position[2] = this._oldPosition[2] + _pos[2]
        this.lookAt[0] = Math.sin(this.currTheta) * Math.cos(this.currPhi) * 100 + this.position[0];
        this.lookAt[1] = Math.sin(this.currPhi) * 100 * -1 + this.position[1];
        this.lookAt[2] = Math.cos(this.currTheta) * Math.cos(this.currPhi) * 100 + this.position[2];
        this.updateMatrix();
        this.updateWorldMatrix();

        this.time = time;

    }
    else {
      super.render(true);
    }

    if (this.frustum) {
      mat4.multiply(this._projScreenMatrix, this.projectionMatrix, this.inverseWorldMatrix );
      this.frustum && this.frustum.setFromProjectionMatrix( this._projScreenMatrix )
    }

  }

}


export default Camera;